export default __webpack_public_path__ + "static/media/fair.720167fd.png";